import React from "react";
import { MapandTransformContainer } from "../../../containers";

const MapandTransform = (props) => {
  return <MapandTransformContainer {...props} />;
};

export default MapandTransform;
